import { deburr } from 'lodash';

/** Cuts `text` to `maxLength` characters and marks the cut with `...`, for a table cell. */
export const getMaxLengthText = (text: string, maxLength: number = 100) => {
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

/** A person's first and last name, or `''` when neither is known. */
export const getFullName = (person?: { first_name?: string | null; last_name?: string | null } | null) => {
  return [person?.first_name, person?.last_name].filter(Boolean).join(' ');
};

/**
 * A text as a slug, close to what the API's `generate_slug` makes from a title: lowercase letters and digits, accents
 * and apostrophes dropped, words joined by single hyphens. `''` for a text with no letter or digit.
 */
export const toSlug = (text: string) =>
  deburr(text)
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
